// New tagged slice for the migrated `_features/products` feature -
// consolidates TWO duplicate injectEndpoints calls that both existed on
// the same apiSlice for /product routes with identical endpoint names
// (the old `features/api/productApiSlice.js`, since removed entirely, and
// features/ProductsFeature/api/productsApi.js - a dev "endpoint already
// exists" collision, not a routing bug like Plans' had).
//
// Drops createProduct/deleteProduct/archiveProduct/getProduct - all
// confirmed zero-consumer repo-wide (creation goes through
// initiateProduct + editProduct; archive/activate flips `status` through
// editProduct too, same as the old, already-correct ProductsFeaturePage).
import { apiRoutes } from "../../../_config/apiRoutes";
import { apiSlice } from "../../../_api/apiSlice";

export const productApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    initiateProduct: builder.mutation({
      query: (data) => ({
        url: apiRoutes.product.initiate.path,
        method: apiRoutes.product.initiate.reqType,
        body: data,
      }),
      invalidatesTags: ["Products"],
    }),
    getAllProduct: builder.query({
      query: (params) => ({
        url: "/product/",
        method: "GET",
        params,
      }),
      providesTags: ["Products"],
    }),
    getAllProductByOrgId: builder.query({
      query: (params) => ({
        url: "/product/all",
        method: "GET",
        params,
      }),
      providesTags: ["Products"],
    }),
    getProductById: builder.query({
      query: (id) => ({
        url: `/product/${id}`,
        method: "GET",
      }),
      providesTags: ["Products"],
    }),
    editProduct: builder.mutation({
      query: (data) => ({
        url: apiRoutes.product.edit.path,
        method: apiRoutes.product.edit.reqType,
        body: data,
      }),
      invalidatesTags: ["Products"],
    }),
  }),
});

export const {
  useInitiateProductMutation,
  useGetAllProductQuery,
  useGetAllProductByOrgIdQuery,
  useLazyGetAllProductByOrgIdQuery,
  useGetProductByIdQuery,
  useEditProductMutation,
} = productApi;
